import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ENDPOINTS } from 'config/endpoints';
import CronoError from 'crono-fe-common/types/error';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { invalidateActivitiesQueries } from 'hooks/services/event/useActivitiesSearch';
import { invalidateTimelineQueries } from 'hooks/services/timeline/useSearchTimeline';
import client from 'utils/clients/client';

const ENDPOINT = ENDPOINTS.events.event;

export interface DeleteEventPayload {
  eventId: number;
  deleteInCrm: boolean;
}

const deleteEvent = (payload: DeleteEventPayload) => {
  const request: Request = {
    url: ENDPOINT,
    config: { method: 'DELETE', data: payload },
  };
  return client(request);
};

export const useDeleteEvent = () => {
  const queryClient = useQueryClient();

  return useMutation<Response<null>, CronoError, DeleteEventPayload>(
    deleteEvent,
    {
      meta: {
        successMessage: 'Meeting deleted',
        errorMessage: 'Failed to delete meeting',
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [ENDPOINT] });
        queryClient.invalidateQueries({
          queryKey: [ENDPOINTS.account.main],
        });
        queryClient.invalidateQueries({
          queryKey: [ENDPOINTS.account.search.main],
        });
        queryClient.invalidateQueries({
          queryKey: [ENDPOINTS.prospect.main],
        });
        queryClient.invalidateQueries({
          queryKey: [ENDPOINTS.prospect.search.main],
        });
        invalidateActivitiesQueries(queryClient);
        invalidateTimelineQueries(queryClient);
      },
    },
  );
};
